import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import FamilyAuthShell, { errorDetail } from "../../components/family/FamilyAuthShell";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function FamilyForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/family/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.status === 429) throw new Error("Troppe richieste: riprova tra qualche minuto");
      if (!res.ok) throw new Error(errorDetail(data, "Non è stato possibile inviare la richiesta"));
      setMessage(data.message || "Se l'indirizzo è associato a un account, riceverai un'email con le istruzioni.");
    } catch (err) {
      setError(err.message || "Non è stato possibile inviare la richiesta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <FamilyAuthShell>
      {message ? (
        <div className="space-y-4 text-center" role="status">
          <h1 className="text-xl font-extrabold">Controlla la tua email</h1>
          <p className="text-sm leading-6 text-slate-600">{message}</p>
          <p className="text-xs leading-5 text-slate-500">Il link è valido per 60 minuti e si può usare una sola volta. Se non trovi l&apos;email, controlla anche la cartella spam.</p>
          <Link to="/family-login" className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#6e48b5] text-sm font-semibold text-white hover:bg-[#5a3b94]">Torna all&apos;accesso</Link>
        </div>
      ) : (
        <>
          <div className="mb-6 text-center">
            <h1 className="text-xl font-extrabold">Password dimenticata?</h1>
            <p className="mt-2 text-sm leading-6 text-slate-600">Inserisci l&apos;email con cui accedi ad AFFIDYA Family: ti invieremo un link per scegliere una nuova password.</p>
          </div>
          <form onSubmit={submit} className="space-y-4" aria-label="Recupero password">
            <div className="space-y-1.5">
              <Label htmlFor="forgot-email">Email</Label>
              <Input id="forgot-email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-xl" />
            </div>
            {error ? <p role="alert" className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p> : null}
            <Button disabled={loading} className="h-11 w-full rounded-xl bg-[#6e48b5] hover:bg-[#5a3b94]">
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Invia il link
            </Button>
            <p className="text-center text-sm"><Link to="/family-login" className="font-medium text-[#6e48b5] hover:underline">Torna all&apos;accesso</Link></p>
          </form>
        </>
      )}
    </FamilyAuthShell>
  );
}
